import { useEffect, useState, useRef } from 'react';
import { Button, Popover } from 'antd';
import DocRate from '../../components/document-rate/rate';
import useDocHelp from './DocHelpHooks';
import DocFeedback from 'src/components/doc-feedback/DocFeedback';
import { getPDF } from 'src/api/components/pdfApi';
import Selection from '../selection/Selection';

// import { ReactComponent as PDF } from 'src/images/feedback/pdf.svg';
import { ReactComponent as Feedback } from 'src/images/feedback/feedback.svg';
// import { ReactComponent as PDFDisabled } from 'src/images/feedback/pdf-disabled.svg';

import { zhAndEnWord } from './../doc-feedback/constant';

import './style.scss';

const DocHelp: React.FC<{ currentVersion: string; docName: string }> = props => {
    const { currentVersion, docName } = props;
    const { rateHook } = useDocHelp();
    const { rateValue, submitRate } = rateHook;

    // 判断是否支持PDF下载
    const [pdfStatus, setPdfStatus] = useState(false);
    const [isShow, setIsShow] = useState<boolean>(false);
    const [lang, setLang] = useState('zh');
    const isZh: boolean = lang === 'zh';

    const feedbackRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const language = window.location.pathname.includes('/en/') ? 'en' : 'zh';
        setLang(language);
        (async () => {
            try {
                const res = await getPDF(currentVersion, language, docName);
                setPdfStatus(() => res.status === 200);
            } catch (error) {
                setTimeout(() => setPdfStatus(false), 500);
            }
        })();
    }, [currentVersion, docName]);

    const goPDF = () => {
        window.open(`https://paddle-site-web.bj.bcebos.com/pdf/${docName}/${currentVersion}/paddlepaddle-${lang}.pdf`);
    };
    return (
        <>
            <div className="paddle-doc-page-rate-feedback-pdf">
                <div className="rate-tips">{isZh ? zhAndEnWord['zh'].help : zhAndEnWord['en'].help}</div>
                <DocRate value={rateValue} onChange={submitRate} />
                <div className="pdf-feedback-btn" ref={feedbackRef}>
                    {/* <Button
                        type="text"
                        disabled={!pdfStatus}
                        onClick={goPDF}
                        icon={<span className="pdf-feedback-btn-icon">{pdfStatus ? <PDF /> : <PDFDisabled />}</span>}
                    >
                        {isZh ? zhAndEnWord['zh'].pdf : zhAndEnWord['en'].pdf}
                    </Button> */}
                    <Popover
                        placement="top"
                        getPopupContainer={() => feedbackRef.current ?? document.body}
                        overlayClassName="pdf-feedback-btn-popover"
                        content={
                            <>
                                <img
                                    className="pdf-feedback-btn-popover-icon"
                                    src={require('./images/feedback-arrow.png')}
                                    alt="反馈提示"
                                />
                                <div>
                                    <div className="pdf-feedback-btn-popover-title">鼠标选取文档内容，精确反馈问题</div>
                                    <div className="pdf-feedback-btn-popover-desc">
                                        选取您有疑问的文档内容并点击反馈，即可更精确地反馈问题，我们将跟进处理
                                    </div>
                                </div>
                            </>
                        }
                    >
                        <Button
                            type="text"
                            onClick={() => {
                                setIsShow(true);
                            }}
                            icon={
                                <span className="pdf-feedback-btn-icon">
                                    <Feedback />
                                </span>
                            }
                        >
                            {isZh ? zhAndEnWord['zh'].feedback : zhAndEnWord['en'].feedback}
                        </Button>
                    </Popover>
                </div>
            </div>
            <DocFeedback {...{ isPdf: pdfStatus, goPDF, isShow, setIsShow }} />
            {isShow && (
                <Selection
                    selectedText="无标记内容"
                    nullText={true}
                    isShow={true}
                    setIsShow={setIsShow}
                    docLang={lang}
                    docVersion={currentVersion}
                />
            )}
        </>
    );
};

export default DocHelp;
